module.exports = __webpack_public_path__ + "static/media/dropdownArrow.25292d4d.svg";